'use client'

import { useEffect } from 'react'

import { useGlobalConfigContext } from '../../global-config'
import { useNextPathname } from '../../next-pathname'
import { urlResolverGetLogin } from '../../url-handling'
import { loginRegistrationGtmPushFullStoryPayload } from '../gtm/events/loginRegistrationGtmPushFullStoryPayload'

export const useLoginRegistrationGtmPushFullStoryTracking = (
  isModalOpen: boolean,
): void => {
  const pathName = useNextPathname()
  const config = useGlobalConfigContext()

  useEffect(() => {
    const isRegister = window.location.hash === '#register'
    const onLoginRoute = pathName === urlResolverGetLogin(config)
    if (isRegister || (!isModalOpen && !onLoginRoute)) {
      return
    }

    loginRegistrationGtmPushFullStoryPayload({
      config,
      isModalOpen,
      pathName,
    })
  }, [config, isModalOpen, pathName])
}
